'use client'

import Link from 'next/link'
import { IconHome } from '@tabler/icons-react'

import { Logo } from '@/components/payload/Logo/Logo'

export function MinimalHeader() {
    return (
        <div className='py-2 flex justify-between items-center gap-2'>
            <Link href='/'>
                <Logo className='h-4 w-full' loading='eager' priority='high' />
            </Link>
            <div className='flex items-center'>
                <Link href='/'>
                    <IconHome className='h-7 w-7' aria-label='Home' />
                </Link>
            </div>
        </div>
    )
}
